(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-gallery-slider"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCardSliders(scope) {
    var containers = (scope || document).querySelectorAll('.card_carousel');

    containers.forEach(function (carousel) {
      if (carousel.classList.contains('swiper-initialized')) return;

      new Swiper(carousel, {
        loop: false,
        pointerCursor: true,
        slidesPerView: 1,
        speed: 400,
        watchSlidesProgress: true
      });
    });
  }

  function initObserver() {
    var target = document.querySelector('.collection') || document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches('.grid__item')) {
            initCardSliders(node);
          }

          var carousels = node.querySelectorAll?.('.card_carousel');
          if (carousels && carousels.length) {
            initCardSliders(node);
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    if (typeof Swiper === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    initCardSliders();
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
  } catch(e) { console.error(e); }
})();

})();
